import type { CustomElement } from "./utils";
import { extendElementAsFormAssociated } from "./extend.formAssociated";
import { extendElementWithInputBehavior } from "./extend.inputBehavior";
import { extendElementBase } from "./extend.base";
import { extendElementWithRenderSliceInit } from "./extend.init.slice.js";
import type { CustomElementExtendOptions } from "./index.ts";
import { extendElementWithOcAutoAriaLabel } from "./extend.useOcAutoAriaLabel.js";

export type ExtendToggles = [change_me: boolean];
/*                                                                  */
/*                    */
/*                  */

window.__components ??= {} as never;
window.__components.extend =
  /**
 *
 */
  (options: CustomElementExtendOptions = {}) =>
    /**
 *
 */
    (customElement) => {
      let result = extendElementBase(customElement as CustomElement, options);

      const { formAssociated, inputBehavior, asyncInit, useOcAutoAriaLabel } = options;

      /*                                                     */
      /*                                              */
      /*                                                                    */
      if (asyncInit && import.meta.env.MODE !== "test" && !import.meta.env.STORYBOOK) {
        result = extendElementWithRenderSliceInit(result);
      }

      /*                                                               */
      if (formAssociated) result = extendElementAsFormAssociated(result);

      /*                                               */
      if (inputBehavior) result = extendElementWithInputBehavior(result);

      /*                          */
      if (useOcAutoAriaLabel) result = extendElementWithOcAutoAriaLabel(result);

      return result;
    };
